export default __webpack_public_path__ + "static/media/partner-section-img.e8987007.svg";